import * as distributors from './distributors'
import * as fridgesWeight from './fridgesWeight'
import * as lockersCold from './lockersCold'
import * as lockersDry from './lockersDry'
import * as terminals from './terminals'

export const allMachines = [
    ...Object.values(distributors),
    ...Object.values(fridgesWeight),
    ...Object.values(lockersCold),
    ...Object.values(lockersDry),
    ...Object.values(terminals),
].sort((previous, current) => previous.name.localeCompare(current.name))
